import { Moment } from 'moment';
import React from 'react';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import { useAppContext } from '../../../Services/AppContext';
import CalendarHealthPlanEvent from './HealthPlanEvent/CalendarHealthPlanEvent';
import { IResponse } from '../../../Services/ApiClient';

export enum CALENDAR_EVENT_TYPE {
	STANDARD_EVENT,
	HEALTH_PLAN_EVENT,
}

export interface CalendarEventProps {
	onEventCreate: (response: IResponse) => void;
	onEventEdit: (response: IResponse) => void;
	type: CALENDAR_EVENT_TYPE;
	params?: {
		patientId?: string;
		healthPlanCode?: HealthPlanCode;
		selectedDate?: Moment | null;
		event?: any;
		caseId?: string;
	};
}

const CalendarEvent: React.FC<CalendarEventProps> = ({
	type,
	params,
	onEventCreate,
	onEventEdit,
}) => {
	const { workplaceId } = useAppContext();

	if (type === CALENDAR_EVENT_TYPE.STANDARD_EVENT) {
		return <></>;
	}

	if (
		type === CALENDAR_EVENT_TYPE.HEALTH_PLAN_EVENT &&
		params?.patientId &&
		params?.healthPlanCode
	) {
		return (
			<CalendarHealthPlanEvent
				healthPlanCode={params.healthPlanCode}
				patientId={params.patientId}
				workplaceId={workplaceId}
				date={params?.selectedDate}
				timeFrom={params?.selectedDate}
				onEventCreate={onEventCreate}
				onEventEdit={onEventEdit}
				event={params?.event}
			/>
		);
	}

	return null;
};

export default CalendarEvent;
